import { render, staticRenderFns } from "./ToolsToolbar.vue?vue&type=template&id=bd47c934&scoped=true"
import script from "./ToolsToolbar.vue?vue&type=script&lang=js"
export * from "./ToolsToolbar.vue?vue&type=script&lang=js"
import style0 from "./ToolsToolbar.vue?vue&type=style&index=0&id=bd47c934&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd47c934",
  null
  
)

export default component.exports